import forumApi from '@/features/forum/services/forumApi';
import { createLegacyPendingRepository } from '@/features/forum/services/forumPendingQueue';
import UserActivityWidget from '../components/UserActivityWidget.vue';
import NavigationLinks from '../components/NavigationLinks.vue';

export default {
  name: 'AdminNeedResponse', components: { UserActivityWidget, NavigationLinks },
  data: () => ({ loading: true, error: null, activeTab: 'all', currentPage: 1, limit: 10,
    allItems: [], counts: null, serverPages: 1, isResolving: false }),
  computed: {
    filteredItems() { return this.allItems; }, items() { return this.allItems; }, totalPages() { return this.serverPages; },
    identityKey() { return JSON.stringify(this.currentIdentity()); }
  },
  watch: {
    '$route.fullPath'(path) { if (path === this.canonicalPath) { this.canonicalPath = null; return; } this.fetchItems(); },
    identityKey() { this.generation++; this.allItems = []; this.counts = null; this.fetchItems(); }
  },
  created() {
    this.generation = 0; this.canonicalPath = null;
    this.repository = createLegacyPendingRepository({ http: forumApi, getIdentity: () => this.currentIdentity() });
    this.fetchItems();
  },
  beforeDestroy() { this.generation++; },
  beforeRouteLeave(to, from, next) { next(!this.isResolving); },
  methods: {
    currentIdentity() { const user = this.$store.getters._g_User || {}; let session = null; try { session = localStorage.getItem('user_access_token'); } catch (_) { /* Restricted browser storage. */ } return { uid: user.uid, roles: user.roles, session }; },
    async fetchItems() {
      const generation = ++this.generation, owner = JSON.stringify(this.currentIdentity());
      this.loading = true; this.error = null; this.allItems = []; this.counts = null;
      const current = () => !this._isDestroyed && this.generation === generation && JSON.stringify(this.currentIdentity()) === owner;
      try {
        const model = await this.repository.read(this.$route.query);
        if (!current()) return;
        this.allItems = model.items; this.counts = model.counts; this.activeTab = model.tab; this.currentPage = model.page; this.serverPages = model.pages;
        if (Number(this.$route.query.page || 1) !== model.page) {
          const target = { name: this.$route.name, params: this.$route.params, query: { ...this.$route.query, page: String(model.page) } };
          this.canonicalPath = this.$router.resolve(target).route.fullPath;
          await this.$router.replace(target).catch(error => { if (error.name !== 'NavigationDuplicated') throw error; });
        }
      } catch (error) {
        if (current()) this.error = error.response?.status === 403 ? 'No tienes permiso para consultar pendientes.' : 'No se pudo consultar la lista. Comprueba su estado antes de continuar.';
      } finally { if (current()) this.loading = false; }
    },
    totalCountForTab(tab) { return this.loading ? '...' : this.counts ? new Intl.NumberFormat('es-ES').format(this.counts[tab]) : '—'; },
    navigate(tab, page) {
      if (this.loading || this.isResolving) return;
      return this.$router.push({ name: this.$route.name, params: this.$route.params, query: { ...this.$route.query, tab, page: String(page) } }).catch(error => { if (error.name !== 'NavigationDuplicated') throw error; });
    },
    changeTab(tab) { if (tab !== this.activeTab) return this.navigate(tab, 1); },
    goToPage(page) { if (page !== this.currentPage) return this.navigate(this.activeTab, Math.max(1, Math.min(page, this.totalPages))); },
    async markAsResolved(item) {
      if (this.isResolving || this.loading || this.error || !this.allItems.includes(item)) return;
      this.isResolving = true; item.resolving = true;
      const owner = JSON.stringify(this.currentIdentity()), generation = this.generation;
      try {
        await this.repository.resolve(item);
        if (!this._isDestroyed && JSON.stringify(this.currentIdentity()) === owner && this.generation === generation) await this.fetchItems();
      } catch (_) {
        if (!this._isDestroyed && JSON.stringify(this.currentIdentity()) === owner && this.generation === generation) this.error = 'No se pudo confirmar el cambio. Comprueba la lista antes de volver a resolver el mensaje.';
      } finally { this.isResolving = false; this.$set(item, 'resolving', false); }
    },
    formatDate(timestamp) { return timestamp ? new Intl.DateTimeFormat('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }).format(new Date(timestamp * 1000)) : ''; },
    truncateText(text, length) { return text.length > length ? text.slice(0, length) + '...' : text; }
  }
};
